import { Flex, Layout, Modal, Space, Tag } from "antd";

import React, { useRef } from "react";
import { useQuery } from "react-query";
import { getTasksStats } from "../../../service";
import { GlobalActions } from "../../molecules";

const { Header: AntHeader } = Layout;

export const Header: React.FC = () => {
  const previousStateRef = useRef<Record<string, number>>({});

  const { data, error, isLoading } = useQuery<any, Error>(
    ["/tasks-stats"],
    () => getTasksStats(),
    {
      onSuccess(data) {
        const currentState = (data?.labels as any[] ?? []).reduce(
          (acc: any, current: any) => {
            const split = current?.text.split(":");
            acc[split[0]] = Number(split[1]);
            return acc;
          },
          {}
        );
        Object.entries(currentState).forEach(([key, value]: any) => {
          if (previousStateRef.current[key] < value) {
            Modal.info({
              title: "Nowe powiadomienie",
              content: `Nowe ${key.toLowerCase()}`,
            });
          }
        });
        previousStateRef.current = currentState;
      },
      refetchInterval: 1000 * 120,
      refetchIntervalInBackground: true,
    }
  );

  const labels = data?.labels ?? [];
  const actions = data?.global_actions ?? [];

  return (
    <AntHeader
      style={{
        height: labels?.length > 0 || actions?.length > 0 ? "50px" : "0px",
        paddingLeft: "4px",
        paddingRight: "4px",
        lineHeight: 0,
        background: "#fff",
      }}
    >
      <Flex
        align="mid"
        style={{
          height: "100%",
        }}
      >
        {!isLoading && !error && (
          <Space wrap>
            {labels.map((label: any) => {
              return (
                <Tag
                  style={{
                    padding: "5px",
                    fontSize: "16px",
                    fontWeight: '600'
                  }}
                  key={label?.color + label?.text}
                  color={label?.color ?? "#000000"}

                >
                  {label?.text}
                </Tag>
              );
            })}
          </Space>
        )}
        <GlobalActions total={1} global_actions={actions} />
      </Flex>
    </AntHeader>
  );
};

